import gql from "graphql-tag";

export default gql`
    mutation($ID: ID!){
        removeLanguage(IdIdioma: $ID) {
            IdIdioma
            Idioma
    }
  }
`;
